import React from 'react';
import { IconButton } from '@mui/material';

const FloatingChatButton = ({ onClick }) => {
  return (
    <IconButton
      aria-label="chat"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        width: 64,
        height: 64,
        bgcolor: 'transparent', // transparent to remove white background
        borderRadius: '50%',
        boxShadow: 6,
        zIndex: 2000,
        transition: 'all 0.3s ease',
        padding: 0, // remove internal white space
        '&:hover': {
          transform: 'scale(1.1)',
          boxShadow: 8
        },
        '&:active': {
          transform: 'scale(0.95)'
        }
      }}
    >
      <div
        style={{
          backgroundColor: 'black',
          borderRadius: '50%',
          width: '100%',
          height: '100%',
          border: '2px solid gold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 6
        }}
      >
        <img
          src="/neo_ami.png"
          alt="AMI Assistant"
          style={{
            width: '80%',
            height: '80%',
            objectFit: 'contain',
            borderRadius: '50%'
          }}
        />
      </div>
    </IconButton>
  );
};

export default FloatingChatButton;
